import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { isValidForm, newForm, newFormField } from '../../../../utils/form';
import { RegexpType, validator } from '../../../../utils/validator';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { UPDATE_PASSWORD } from '../../../../app/redux/actions/user';
import { InputWrapper, ModalBody } from './style';

const initialForm = newForm([
  newFormField({
    field: 'password',
    required: true,
    type: RegexpType.PASSWORD,
    valid: true,
  }),
  newFormField({
    field: 'new_password',
    required: true,
    type: RegexpType.RESET_PASSWORD,
    valid: true,
  }),
  newFormField({
    field: 'confirmPwd',
    required: true,
    type: RegexpType.PASSWORD,
    valid: true,
  }),
]);

const defaultType = {
  pwd: 'password',
  newPwd: 'password',
  confirmPwd: 'password',
};

const CTAType = ({ currentType, typeKey, callback }) => {
  return (
    <CTA
      type="tertiary"
      btnText={currentType === 'text' ? 'Nascondi password' : 'Mostra password'}
      onClick={() => callback(typeKey)}
      icon={currentType === 'text' ? 'eye-off' : 'eye'}
    />
  );
};
CTAType.propTypes = {
  currentType: PropTypes.oneOf(['text', 'password']),
  typeKey: PropTypes.oneOf(Object.keys(defaultType)),
  callback: PropTypes.func,
};

export const ModalPwdChangeId = 'ModalPwdChange';

const ModalPwdChange = ({ mediaIsPhone, modalClose, updatePassword }) => {
  const scrollableAreaRef = useRef(null);
  const [form, setForm] = useState(initialForm);
  const [inputType, setInputType] = useState(defaultType);

  const handleOnChange = (field = '', newValue) => {
    const { type } = form[field];
    setForm({
      ...form,
      [field]: {
        ...form[field],
        value: newValue,
        valid:
          (typeof newValue !== 'object'
            ? validator(type, newValue, true)
            : true) &&
          (field === 'confirmPwd'
            ? form.new_password.value === newValue
            : true),
      },
    });
  };

  const handleChangeType = (key = '') => {
    const newType = { ...inputType };
    newType[key] = inputType[key] === 'text' ? 'password' : 'text';
    setInputType(newType);
  };

  return (
    <Modal
      title="Modifica password"
      modalId={ModalPwdChangeId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea ref={scrollableAreaRef} style={{ maxWidth: `${mediaIsPhone ? 'none' : '600px'}` }}>
        <ModalBody>
          <InputWrapper>
            <Text type="h3" mb={8}>
              Inserisci la tua password
            </Text>
            <CustomInput
              type={inputType.pwd}
              placeholder="Password"
              className="modal-input"
              value={form.password.value}
              valid={form?.password?.valid}
              onChange={(v) => handleOnChange('password', v)}
              autocomplete="new-password"
            />
          </InputWrapper>
          <InputWrapper>
            <Text type="h3" mb={8}>
              Inserisci nuova password
            </Text>
            <CustomInput
              type={inputType.newPwd}
              placeholder="Password"
              className="modal-input"
              value={form.new_password.value}
              valid={form?.new_password?.valid}
              error="La password deve contenere almeno 8 caratteri, inclusi 1 lettera maiuscola, 1 lettera minuscola, 1 numero e 1 carattere speciale"
              onChange={(v) => handleOnChange('new_password', v)}
              autocomplete="new-password"
            />
            <CTAType
              currentType={inputType.newPwd}
              typeKey="newPwd"
              callback={handleChangeType}
            />
          </InputWrapper>
          <InputWrapper>
            <Text type="h3" mb={8}>
              Conferma nuova password
            </Text>
            <CustomInput
              type={inputType.confirmPwd}
              placeholder="Password"
              className="modal-input"
              value={form.confirmPwd.value}
              valid={form?.confirmPwd?.valid}
              error="Le password devono coincidere"
              onChange={(v) => handleOnChange('confirmPwd', v)}
              autocomplete="new-password"
            />
            <CTAType
              currentType={inputType.confirmPwd}
              typeKey="confirmPwd"
              callback={handleChangeType}
            />
          </InputWrapper>
        </ModalBody>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          onClick={() => {
            updatePassword({
              password: form?.password?.value,
              newPassword: form?.new_password?.value,
            });
            setForm(initialForm);
            modalClose();
          }}
          disabled={!isValidForm(form)}
        />
      </Footer>
    </Modal>
  );
};

ModalPwdChange.propTypes = {
  mediaIsPhone: PropTypes.bool,
  modalClose: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      return {};
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      updatePassword: (payload) =>
        dispatch({ type: UPDATE_PASSWORD._REQUEST, payload }),
    })
  ),
  withMediaQueries
)(ModalPwdChange);
